import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { useEffect, useState } from 'react';
import { useCoreApi, useAppState } from '../context/clientHeader';
export function useConsentCommunications() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$shouldFetch = _ref.shouldFetch,
    shouldFetch = _ref$shouldFetch === void 0 ? true : _ref$shouldFetch;
  var coreApi = useCoreApi();
  var _useAppState = useAppState(),
    personId = _useAppState.personId,
    providerId = _useAppState.providerId;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  useEffect(function () {
    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$coreApi$query, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return coreApi.query('communication', {
                category: 'consent_request',
                person: personId,
                'sender.provider': providerId
              }, {
                page: {
                  number: 1,
                  size: 1
                }
              });
            case 2:
              _yield$coreApi$query = _context.sent;
              data = _yield$coreApi$query.data.data;
              setData(data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (personId && providerId && shouldFetch) {
      load();
    }
  }, [coreApi, personId, providerId, shouldFetch]);
  return {
    hasSome: !!data && data.length > 0,
    areLoaded: data !== null
  };
}
//# sourceMappingURL=useConsentCommunications.js.map